import { AritoIcon, AritoFormV2, BottomActionBarV2, DialogV2, HeaderTabsV2 } from '@/components/custom/erp';
import { initialValues, searchSchema } from '../schema';
import { useSearchFieldStates } from '../hooks';
import { BasicInfo, DetailsTab } from './tabs';

interface InitialSearchDialogProps {
  onClose: () => void;
  onSearch: (data: BanHangPayload) => void;
}

export const InitialSearchDialog: React.FC<InitialSearchDialogProps> = ({ onClose, onSearch }) => {
  const searchFieldStates = useSearchFieldStates();

  const handleSubmit = (data: BanHangPayload) => {
    const combinedData = {
      ...data,
      ngay_ct: data.ngay_ct,
      group_by: data.group_by.join(','),
      tk: searchFieldStates.account?.uuid || null,
      ma_kh: searchFieldStates.customer?.uuid || null,
      nh_kh1: searchFieldStates.customerGroup1?.uuid || null,
      nh_kh2: searchFieldStates.customerGroup2?.uuid || null,
      nh_kh3: searchFieldStates.customerGroup3?.uuid || null,
      ma_khu_vuc: searchFieldStates.region?.uuid || null
    };

    onSearch({ data: combinedData, tk: searchFieldStates.account });
  };

  return (
    <DialogV2
      open={true}
      onClose={onClose}
      title='Báo cáo số dư công nợ'
      maxWidth='lg'
      disableBackdropClose={false}
      disableEscapeKeyDown={false}
      titleIcon={<AritoIcon icon={12} />}
    >
      <AritoFormV2
        mode='search'
        hasAritoActionBar={false}
        schema={searchSchema}
        initialData={initialValues}
        onSubmit={handleSubmit}
        className='w-full'
        headerFields={
          <div className='max-h-[calc(100vh-150px)] w-[800px] min-w-[800px] overflow-y-auto'>
            <BasicInfo
              searchFieldStates={{ account: searchFieldStates.account, setAccount: searchFieldStates.setAccount }}
            />

            <HeaderTabsV2
              tabs={[
                {
                  id: 'details',
                  label: 'Chi tiết',
                  component: (
                    <DetailsTab
                      searchFieldStates={{
                        customer: searchFieldStates.customer,
                        setCustomer: searchFieldStates.setCustomer,
                        customerGroup1: searchFieldStates.customerGroup1,
                        setCustomerGroup1: searchFieldStates.setCustomerGroup1,
                        customerGroup2: searchFieldStates.customerGroup2,
                        setCustomerGroup2: searchFieldStates.setCustomerGroup2,
                        customerGroup3: searchFieldStates.customerGroup3,
                        setCustomerGroup3: searchFieldStates.setCustomerGroup3,
                        region: searchFieldStates.region,
                        setRegion: searchFieldStates.setRegion
                      }}
                    />
                  )
                }
              ]}
            />
          </div>
        }
        bottomBar={<BottomActionBarV2 mode='search' onClose={onClose} />}
      />
    </DialogV2>
  );
};

export default InitialSearchDialog;
